import { useEffect, useState } from "react";
import axios from "axios";
import { Image as ImageIcon, ArrowsClockwise } from "@phosphor-icons/react";
import { API } from "./shared";
import { requestListPhoto } from "./photoRequests";

export const CtnPhoto = ({ id, alt = "Productfoto", testId, variant = "actief", revision = 0 }) => {
  const [url, setUrl] = useState("");
  const [failed, setFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!id) return;
    let active = true, objectUrl;
    setUrl(""); setFailed(false);
    const controller = new AbortController();
    const request = variant === "lijst" ? requestListPhoto : axios.get;
    request(`${API}/fotos/${id}`, { params: { variant }, responseType: "blob", signal: controller.signal, ...(variant === "lijst" ? { timeout: 30000 } : {}) }).then(({ data }) => {
      if (active) { objectUrl = URL.createObjectURL(data); setUrl(objectUrl); }
    }).catch((e) => { if (active && !axios.isCancel(e)) setFailed(true); });
    return () => { active = false; controller.abort(); if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [id, attempt, variant, revision]);
  if (!id) return <div className="ctn-photo-placeholder" data-testid={testId}><ImageIcon size={36} weight="light" /></div>;
  if (failed) return <button type="button" className="ctn-photo-placeholder" title="Foto opnieuw laden" aria-label="Foto opnieuw laden" onClick={() => setAttempt(attempt + 1)} data-testid={`${testId}-retry`}><ArrowsClockwise size={22} /></button>;
  return url ? <img src={url} alt={alt} className="ctn-photo" loading="lazy" decoding="async" data-testid={testId} /> : <div className="ctn-photo-placeholder animate-pulse" data-testid={`${testId}-loading`}><ImageIcon size={32} /></div>;
};